import React from 'react'
import styled, { css } from 'styled-components'
import { node } from 'prop-types'

import * as spacing from 'styles/spacing'
import { media } from 'styles/media'

const Container = styled.div`
  flex: 1;

  ${media.xLarge`
    max-width: 1800px;
    margin-left: auto;
    margin-right: auto;
  `};
`

const Inner = styled.div`
  display: grid;
  grid-gap: ${spacing.medium};

  ${media.xSmall`
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: 1fr auto;
  `};

  ${media.small`
    grid-gap: ${spacing.large};
  `};

  ${media.medium`
    grid-gap: ${spacing.xLarge};
  `};

  ${media.large`
    grid-template-columns: repeat(3, 1fr);
    grid-gap: ${spacing.xxLarge};
  `};

  ${media.xLarge`
    grid-gap: ${spacing.xxxLarge};
  `};
`

const Item = styled.div`
  display: flex;

  ${props =>
    props.hidden &&
    css`
      display: none;
    `}
`

const CartridgeList = ({ children }) => (
  <Container>
    <Inner>
      {React.Children.map(children, (child, i) => (
        <Item key={i} hidden={child.props.hidden}>
          {child}
        </Item>
      ))}
    </Inner>
  </Container>
)

CartridgeList.propTypes = {
  children: node.isRequired
}

export default CartridgeList
